
import React from 'react';
import { PollOption } from '@/types/group';
import { Button } from '@/components/ui/button';
import { Check } from 'lucide-react';
import { calculatePercentage, isUserVoteForOption } from './utils/pollUtils';

interface PollOptionItemProps {
  option: PollOption;
  totalVotes: number;
  userId?: string;
  isPollClosed: boolean;
  isVoting: boolean;
  onVote: (optionId: string) => void;
}

const PollOptionItem: React.FC<PollOptionItemProps> = ({
  option,
  totalVotes,
  userId,
  isPollClosed,
  isVoting,
  onVote
}) => {
  const percentage = calculatePercentage(option.vote_count || 0, totalVotes);
  const isUserVote = isUserVoteForOption(option, userId);

  return (
    <div className="space-y-1">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          {isUserVote && (
            <Check className="h-4 w-4 text-green-500 mr-1 flex-shrink-0" />
          )}
          <span>{option.option_text}</span>
        </div>
        <span className="text-sm font-medium">{percentage}%</span>
      </div>
      
      <div className="relative h-2 w-full bg-gray-100 rounded overflow-hidden">
        <div 
          className="absolute top-0 left-0 h-full bg-glowingTeal transition-all duration-500"
          style={{ width: `${percentage}%` }}
        />
      </div>
      
      <div className="flex items-center justify-between">
        <span className="text-xs text-gray-500">
          {option.vote_count || 0} {(option.vote_count || 0) === 1 ? 'vote' : 'votes'}
        </span>
        
        {!isPollClosed && !isVoting && (
          <Button
            size="sm"
            variant={isUserVote ? "secondary" : "outline"}
            className="text-xs h-7 px-2"
            onClick={() => onVote(option.id)}
            disabled={!userId}
          >
            {isUserVote ? 'Voted' : 'Vote'}
          </Button>
        )}
      </div>
    </div>
  );
};

export default PollOptionItem;
